import { Spinner } from './PageLoader';

const LoadingSpinner = () => (
  <div className='flex w-full items-center justify-center py-10'>
    <Spinner />
  </div>
);

export default LoadingSpinner;
